import { render } from "./ProductDetailPageContent.vue?vue&type=template&id=00851580&ts=true"
import script from "./ProductDetailPageContent.vue?vue&type=script&lang=ts"
export * from "./ProductDetailPageContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__